<script lang="ts">
  import { pluralize } from "@shared/svelte/Modules/pluralize";
  import Icon from "@shared/svelte/Components/Icon.svelte";

  export let previousOrder;

  const createProductList = orderProducts => {
    let list = "(";
    orderProducts.forEach((product, index) => {
      if (product.vintage_year) {
        list += `${product.vintage_year} `;
      }

      if (product.container_label) {
        list += `${product.container_label} - `;
      } else {
        list += `${product.container_type} - `;
      }

      if (product.case_quantity > 0) {
        list += `${pluralize("case", product.case_quantity, true)}${
          product.unit_quantity > 0 ? ", " : ""
        }`;
      }
      if (product.unit_quantity > 0) {
        list += `${pluralize(product.container_type, product.unit_quantity, true)}`;
      }
      if (orderProducts.length > 1 && index < orderProducts.length - 1) {
        list += "; ";
      }
    });
    return (list += ")");
  };

</script>

<div class="fizz-surface-gray" data-testid="last-ordered-container">
  <p
    class="fizz-flex-row fizz-align-content-start fizz-inset-square-8 fizz-text-small fizz-text-subdued"
  >
    <span class="margin-right--none">
      <Icon fill="#595959" width={16} height={16} type="History" extraClassNames="fizz-inline-4" />
    </span>

    <span class="fizz-text-strong"
      >Last ordered on {previousOrder.submitted_at}:
      <span class="fizz-text-regular">
        {#each previousOrder.orders as order, index}
          {order.distributor_name}
          {createProductList(
            order.order_products
          )}{#if previousOrder.orders.length > 1 && index < previousOrder.orders.length - 1},&nbsp;{/if}
        {/each}
      </span>
    </span>
  </p>
</div>
